// React/Vue 等框架推荐使用 Hook 封装
import { useLayoutEffect, useState } from "react"

const getViewportWidth = () => {
  return Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  )
}
export const usePageWidth = () => {
  const [width, setWidth] = useState(getViewportWidth())

  useLayoutEffect(() => {
    const handleResize = () => setWidth(getViewportWidth())
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return width
}

const getViewportHeight = () => {
  return Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0,
  )
}
const getCanvastHeight = () => {
  return document.getElementById("canvas").clientHeight
}
export const usePageHeight = () => {
  const [height, setHeight] = useState(getViewportHeight())

  useLayoutEffect(() => {
    const handleHeightResize = () => setHeight(getViewportHeight())
    window.addEventListener("resize", handleHeightResize)
    return () => window.removeEventListener("resize", handleHeightResize)
  }, [])

  return height
}

export const useCanvasHeight = () => {
  const [height, setHeight] = useState(getCanvastHeight())

  useLayoutEffect(() => {
    const handleHeightResize = () => setHeight(getCanvastHeight())
    window.addEventListener("resize", handleHeightResize)
    return () => window.removeEventListener("resize", handleHeightResize)
  }, [])

  return height
}
